import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import { Box, Button, Paper } from '@mui/material';

import { FolderTypology } from '@/features/easy/preFolderQualification/withoutRORO/types';

import {
  stylesFolderTypologyChoice,
  stylesFolderTypologyChoiceText,
  stylesFolderTypologyChoiceButton,
} from './FolderTypologyChoice.styles';
import { TypologyImage } from './TypologyImage';

export type FolderTypologyChoiceProps = {
  folderId: string;
  folderTypology: FolderTypology;
  handleCreateFolderTypology: ({ folderId, folderTypologyId }: { folderId: string; folderTypologyId: string }) => void;
};
export const FolderTypologyChoice: React.FunctionComponent<FolderTypologyChoiceProps> = ({
  folderId,
  folderTypology,
  handleCreateFolderTypology,
}) => {
  const { t } = useTranslation('easy_prefolder');

  const chooseTypology = () => {
    handleCreateFolderTypology({
      folderId,
      folderTypologyId: folderTypology.folderTypologyId,
    });
  };

  return (
    <Box component={Paper} elevation={0} sx={stylesFolderTypologyChoice}>
      <TypologyImage folderTypologyTranslationKey={folderTypology.descriptionTranslationKey} />
      <Box sx={stylesFolderTypologyChoiceText}>
        <ReactMarkdown>{t(`easy.prefolder.${folderTypology.descriptionTranslationKey}.text`)}</ReactMarkdown>
      </Box>
      <Button
        size='large'
        color='primary'
        variant='contained'
        aria-label={`folder-prefolderTypology-choice-submit-${folderTypology.descriptionTranslationKey}`}
        sx={stylesFolderTypologyChoiceButton}
        onClick={chooseTypology}
      >
        {t(`easy.prefolder.${folderTypology.descriptionTranslationKey}.buttonText`)}
      </Button>
    </Box>
  );
};
